export const formatAirScheduleDate = (startDate?: string, endDate?: string) => {
  const starting = startDate
    ? startDate
    : `${new Date().toISOString().split('T')[0]}T06:00:00-04:00`;

  const endingAfter = endDate === '' ? undefined : endDate;
  
  const dates = {
    starting,
    endingAfter,
  };
  return dates;
};
